import Named from '../type/base/Named';

export default ({name}: Named): string => name;
